export const TENANT_STORAGE_KEY = 'selectedTenant';

export enum TenantState {
  READY = 'READY',
  IMPORTING = 'IMPORTING',
  REMOVING = 'REMOVING',
  FAILED = 'FAILED'
}
